import { render } from "./IsPartnerLinks.vue?vue&type=template&id=5cb0c60a"
import script from "./IsPartnerLinks.vue?vue&type=script&lang=js"
export * from "./IsPartnerLinks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__